<div [class]="classDiv">
  <h5 class="heading pull-left"><i [class]="titleIcon"></i> {{title}}</h5>
  <span class="see_more pull-right">
    <a [routerLink]="linkSeeMore">{{textSeeMore}}</a>
  </span>
  <div class="clearfix"></div>
</div>
